import React, { useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { Link, useNavigate } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import Swal from 'sweetalert2';
import api from '../Axios/api';

const IndentDetailTable = ({ data, type }) => {

    const navigation = useNavigate();

    const handleSendItem = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to send item for comparison?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, send it!',
        });
    
        if (result.isConfirmed) {
            try {
                await api.patch(`purchase/toggle-return-item-status/${id}`);
    
                await Swal.fire('Sent!', 'The item has been sent.', 'success');
    
                if (data.length === 1) {
                    navigation('/returnList');
                }
            } catch (error) {
                console.error('Error sending item:', error);
                Swal.fire('Error', 'Failed to send the item.', 'error');
            }
        }
    };
    
    const columns = useMemo(
        () => [
            {
                accessorKey: 'item_group',
                header: 'Item Group',
                size: 200,
            },
            {
                accessorKey: 'item_title',
                header: 'Item',
                size: 150,
                Cell: ({ cell }) => (
                    <div className="max-h-10 overflow-y-auto">
                        {cell.getValue()}
                    </div>
                ),
            },
            {
                accessorKey: 'place_of_use',
                header: 'Remark',
                size: 200,
            },
            {
                accessorKey: 'required_qty',
                header: 'Required qty',
                size: 100,
                Cell: ({ row }) => `${row.original.required_qty} / ${row.original.item_unit}`, // or `${cell.getValue()} /kg` if you mean per kg
              },
              
            {
                accessorKey: 'remark',
                header: 'Place of use',
                size: 200,
            },
            {
                accessorKey: 'current_stock',
                header: 'Current Stock',
                size: 100,
            },
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data,
        enableRowActions: type,
        positionActionsColumn: 'right',
        renderRowActions: ({ row }) => (
            <div className='flex items-center gap-2'>
                <Link to={`/return-purchase-edit/${row.original._id}`}>
                    <button>
                        <Pencil size={18} />
                    </button>
                </Link>
                <button
                    onClick={() => handleSendItem(row.original._id)}
                    className="bg-blue-500 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-600 transition-all duration-200"
                >
                    Send
                </button>
            </div>
        ),
        enableRowSelection: type ? false : true,
        renderToolbarAlertBannerContent: (tableInstance) => {
            const selectedRowIds = Object.keys(tableInstance.table.getState().rowSelection);
            const selectedRows = selectedRowIds.map(id => tableInstance.table.getRow(id).original);
            const ids = selectedRows.map((item) => item._id);
            return (
                <div className='flex items-center gap-3'>
                    {tableInstance.selectedAlert}
                    <div className='text-sm text-[#36C2CE] cursor-pointer'
                        onClick={() => navigation(`/add-purchase-details`, { state: { ids } })}
                    >
                        Add Rate
                    </div>
                </div>
            );
        }
    });
    
    return (
        <div>
            <MaterialReactTable table={table} />
        </div>
    );
};

export default IndentDetailTable;
